<template>
	<div>
		<div class="drop-down" @click.stop="showOption">
			<span v-if="valueShow==''">请选择</span>
			<span v-else>{{ valueShow }}</span>
			<van-icon name="arrow-down" class="drop-icon"/>
			<div class="drop-list" v-show="showList">
				<div class="drop-tip" v-if="optionList.length==0">暂无数据</div>
				<div v-show="optionList.length!=0">
					<div
						class="drop-option"
						v-for="(item,index) in optionList"
						:key="index"
						@click.stop="selectOption(item)"
					>{{ item.name }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		optionData: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			showList: false,
			valueShow: '',
			optionList: this.optionData,
			optionId: ''
		}
	},
	watch: {
		// 正确给 cData 赋值的 方法
		optionData(value) {
			this.optionList = value
		}
	},
	methods: {
		// 显示选项
		showOption() {
			this.showList = true
		},
		// 不设置默认选项
		emptyOption() {
			this.valueShow = ''
			this.optionId = ''
		},
		// 设置默认选项
		setOption(id) {
			this.optionId = id
			this.optionList.forEach((item, index) => {
				if (item.id == this.optionId) {
					this.valueShow = item.name
				}
			})
		},
		//  关闭选项
		closeOption() {
			this.showList = false
		},
		//  选择选项
		selectOption(item) {
			this.showList = false
			this.valueShow = item.name
			this.$emit('selectValue', item)
			this.$emit('change', item.id)
		}
	}
}
</script>
<style scoped lang="less">
.drop-down {
	font-size: var(--base-px-14) !important;
	height: var(--base-px-30);
	display: flex;
	align-items: center;
	width:  var(--base-px-280);
	height: var(--base-px-37);
	line-height: var(--base-px-37);
	padding-left: var(--base-px-10);
	background: #fff;
	color: #8D8D8D;
	position: relative;
	cursor: pointer;
	border: var(--base-px-1) solid #eee;
	border-radius: var(--base-px-5);
}

.drop-icon {
	position: absolute;
	top: var(--base-px-10);
	right: var(--base-px-10);
	color: #8D8D8D;
}

.drop-list {
	width:  var(--base-px-290);
	margin: 0;
	padding: 0;
	max-height:  var(--base-px-300);
	overflow-x: hidden;
	overflow-y: scroll;
	background: #fff;
	position: absolute;
	z-index: 10000;
	top: var(--base-px-37);
	left: 0;
	border-radius: var(--base-px-5);
	box-shadow: var(--base-px-1) var(--base-px-5) var(--base-px-10) #888888;
}

.drop-option {
	width: 100%;
	height: var(--base-px-57);
	line-height: var(--base-px-57);
	margin-left: var(--base-px-14);
}

.drop-option:hover {
	background: #E6F7FF;
}

.drop-tip {
	width: calc(100% - var(--base-px-30));
	height: var(--base-px-57);
	line-height: var(--base-px-57);
	padding-left: var(--base-px-14);
}
</style>
